import { Img } from '@/components/blocks/MaterialImage';
import { useLocalization } from '@/data/Localization';
import { Box, Divider, Typography } from '@mui/material';
import { FC } from 'react';
import { CDN_BASE_URL } from 'shared/custom/constants/commonConstants';

export const EmptyRecentOrdersBox: FC = () => {
	const HeaderMyRecentOrdersLabels = useLocalization('HeaderMyRecentOrderPanel');
	return (
		<>
			<Box display="flex" alignItems="center" flexDirection={'column'} px={'20px'} py={'15px'}>
				<Typography variant="bodySubText" mb={1} color={'grey.500'}>
					{HeaderMyRecentOrdersLabels.ExtraLinks.EmptyList.Text.t()}
				</Typography>
				<Img width={90} height={90} src={`${CDN_BASE_URL}/assets/img/empty-orders.svg`} alt={HeaderMyRecentOrdersLabels.ExtraLinks.EmptyList.Text.t()} />
			</Box>
			<Divider />
		</>
	);
};
